'use client';

import { Target } from '@/lib/types';
import { createURL } from '@/lib/utils';
import { Breadcrumb, Empty, LinkBox, Section } from '@/ui';
import { Content } from '@/widgets';
import { Center, Container, Loader } from '@mantine/core';
import { notFound, useParams } from 'next/navigation';
import useSWR from 'swr';

type MenuItem = {
  id: number;
  title: string;
  url: string;
  target: Target;
};

type Menu = {
  parent_title: string;
  data: MenuItem[];
};

export default function GeneralMenu() {
  const { menu_id } = useParams();

  const { data: menu, isLoading } = useSWR<Menu>(
    menu_id
      ? ['/authorities/lists/get-right-menu?menu_id=${menu_id}&parent=true', { params: { parent: true, menu_id } }]
      : null
  );

  if (!isLoading && !menu?.parent_title?.trim()) notFound();

  const breadcrumbItems = [{ title: menu?.parent_title || '', isCurrent: true }];

  return (
    <Container>
      <Section
        rightMenu={{
          isActive: true,
          id: Number(menu_id),
          activeItem: { title: menu?.parent_title || '' },
        }}
      >
        <Content>
          {isLoading ? (
            <Center h={400}>
              <Loader />
            </Center>
          ) : menu?.parent_title?.trim() ? (
            <>
              <Content.Header>
                <Breadcrumb items={breadcrumbItems} />
              </Content.Header>
              <Content.Title>{menu?.parent_title}</Content.Title>
              <Content.Body className="flex flex-col gap-5" isShareable>
                {menu?.data && menu?.data?.length > 0 ? (
                  menu?.data?.map((item) => (
                    <LinkBox url={createURL(item?.url)} target={item?.target} key={item?.id}>
                      {item?.title}
                    </LinkBox>
                  ))
                ) : (
                  <Empty />
                )}
              </Content.Body>
            </>
          ) : null}
        </Content>
      </Section>
    </Container>
  );
}
